import { Component, Input, OnInit } from '@angular/core';
import { CustomerAccountBusinessLogicService } from 'src/app/services/customer-account-business-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {

  @Input() cardComponents: any[] = [];
  serviceList: any[] = [];
  currentCards: any = {};
  selectedService: any = '';

  constructor(public rootScope: RootScopeService, public custAccSerice: CustomerAccountBusinessLogicService) { }

  ngOnInit() {
    this.getDefaultService();
    this.getServiceList();
    this.updateCurrentCards();
  }

  ngOnChanges() {
    this.getDefaultService();
    this.getServiceList();
    this.updateCurrentCards();
  }


  /**
   * Retrieves the list of services from the card components.
   * It maps over the card components and parses the `propertyValue`
   * of each component to extract the `Service` property.
   * 
   * @returns {Array<any>} An array of services extracted from the card components.
   */
  getServiceList() {
    this.serviceList = this.cardComponents?.map(item => {
      return JSON.parse?.(item?.propertyValue)?.Service;
    });
  }

  /**
   * Updates the current cards based on the selected service from the client info.
   * It retrieves the service associated with the active customer tab and searches 
   * through the card components to find the matching card. If no matching card is found, 
   * the first card in the list is set as the current card.
   *
   * @returns {void} This method does not return a value.
   */
  updateCurrentCards() {
    if (!this.selectedService) {
      this.selectedService = this.rootScope.clientInfoCard?.defaultClientInfoServiceVSClientIdMap?.[this.rootScope.activeCustTab?.clientId]?.service;  
    }

    this.currentCards = this.cardComponents?.find((item) => 
      JSON.parse?.(item?.propertyValue)?.Service === this.selectedService
    ) || this.cardComponents?.[0];

    if (this.selectedService === 'NA') {
      this.selectedService = JSON.parse?.(this.currentCards?.propertyValue)?.Service;
    }
    
    return this.currentCards;
  }

  /**
   * Retrieves the default service for the currently active customer tab.
   * It accesses the client ID from the root scope and uses it to find
   * the corresponding default service from the client information card.
   * The selected service is then updated with the retrieved default service.
   *
   * @returns {void} This method does not return a value.
   */
  getDefaultService() {
    const clientId = this.rootScope.activeCustTab?.clientId;
    const defaultService = this.rootScope?.clientInfoCard?.defaultClientInfoServiceVSClientIdMap?.[clientId]?.service;
    this.selectedService = defaultService;

  }

  /**
   * Checks if the provided service is the currently selected service.
   *
   * @param service - The service to check against the selected service.
   * @returns True if the provided service is the selected service, otherwise false.
   */
  checkSelectedService(service: any) {
    return this.selectedService === service;
  }


  /**
   * Sets the selected service and updates the current cards based on the selected service.
   * 
   * @param service - The service to be selected and used for filtering card components.
   * 
   * @remarks
   * This method checks if there are any card components available. If so, it searches for
   * the card component whose property value matches the selected service.
   */
  viewService(service: any) {
    this.selectedService = service;
    if (this.cardComponents && this.cardComponents?.length > 0) {
      this.currentCards = this.cardComponents?.find((item) => {
        return JSON.parse?.(item?.propertyValue)?.Service == service;
      });
    }
  }


  onRefreshClickAction() {
    console.log("method onRefreshClickAction called ")
    this.custAccSerice.getClientInfoCardData(this.rootScope.activeCustTab.clientId, true);
  }


}
